// extracted by mini-css-extract-plugin
export var contentwrapper = "Layout-module--contentwrapper--0ffb0";
export var footercontainer = "Layout-module--footercontainer--ad1ba";
export var inner = "Layout-module--inner--b8839";
export var layoutcontainer = "Layout-module--layoutcontainer--ae276";